import React, { useState, useEffect } from 'react'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../../../images/nodata.png'
import { getDocumentByUserId, getPendingDocumentByUSedId, DirectDownloadAnyFileByFileName } from '../../../AdminActionCreator.component';
import { SaveUploadFileDocDetails } from '../../DealerActioncreator';


import Loader from '../../../../../presentationals/Loader/Loader.component';
import Popup from '../../../../../presentationals/Popup/Popup.component';
const itemsPerPage = 10;
export default function Main({ allDetail, userDetails }) {
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [AddDocumentPopup, setAddDocumentPopup] = useState(false);
    const [viewDocumentPopup, setViewDocumentPopup] = useState({ show: false, data: {} })
    const [uploadDocumentData, setuploadDocumentData] = useState({ file: '', documentNameSelected: '', documentName: '' })
    const [ListData, setListData] = useState([])
    const [popupListData, setPopupListData] = useState([])
    const [disableSelectBox, setdisableSelectBox] = useState(false)
    const [PopupData, setPopupData] = useState({ show: false, popupData: '' })
    const actionHandler = (type, data) => {
        if (type === "view") {
            setViewDocumentPopup({ show: true, data: data })
        } else if (type === "edit") {
            setuploadDocumentData((prev) => ({ ...prev, documentNameSelected: data?.documentName }))
            getPendingDocumentByUSedIdFunction(data?.documentId)
        } else if (type === "add") {
            getPendingDocumentByUSedIdFunction("")

        } else if (type === "closePopup") {
            setdisableSelectBox(false)
            setPopupListData([])
            setListData([])
            setAddDocumentPopup(false)
            setuploadDocumentData({ file: '', documentNameSelected: '', documentName: '' })
            setViewDocumentPopup({ show: false, data: {} })
        }
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
    }

    const handleUploadFile = (e, type) => {
        if (type === "docName") {
            const arr = ListData && ListData?.length > 0 ? ListData?.filter((el) => { return el.name === e.target.value }) : []
            setPopupListData(arr)
            setuploadDocumentData((prev) => ({
                ...prev,
                documentNameSelected: e.target.value,

            }))
        } else if (type === "docupload") {
            setuploadDocumentData((prev) => ({
                ...prev,
                documentName: e.target.files[0].name,
                file: e.target.files[0]
            }))
        }
    }

    useEffect(() => {
        getDocumentByUserIdAPI(currentPage)
    }, [])

    const getDocumentByUserIdAPI = (page) => {
        setLoader(true)
        getDocumentByUserId(page, itemsPerPage, allDetail?.userId, (callback) => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                settableData(callback?.data)
            } else {
                settableData([])
            }
        })
    }

    const getPendingDocumentByUSedIdFunction = (docId) => {
        setLoader(true)
        getPendingDocumentByUSedId(allDetail?.userId, docId, (callback) => {
            setLoader(false)
            if (callback && callback.message == "success" && callback?.status == 200 && callback?.data?.length > 0) {
                setListData(callback?.data)
                if (docId !== "" && docId !== null && docId !== undefined) {
                    setPopupListData(callback?.data)
                    setdisableSelectBox(true)
                }
                setAddDocumentPopup(true)
            } else {
                setPopupData({ show: true, popupData: "No Documents are Pending" })
                setListData([])
                removePopup()
            }
        })
    }

    const getDates = (time) => {

        const date = new Date(time);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    const concatenatedString = (data) => {
        let str = "";
        data?.map(value => {
            str = str?.length > 0 ? str + ", " + value : value
        })

        return str
    }

    const handleSave = () => {
        let multipartFormData = new FormData();
        multipartFormData.append("fileName", uploadDocumentData.documentNameSelected);
        multipartFormData.append("file", uploadDocumentData?.file);
        multipartFormData.append("documentId", popupListData[0]?.documentId);
        multipartFormData.append("type", getFileExt(uploadDocumentData.documentName));
        // multipartFormData.append("fileName", uploadDocumentData.documentName);
        multipartFormData.append("userId", allDetail?.userId);
        multipartFormData.append("replaceOrUpload", disableSelectBox === false ? 0 : disableSelectBox === true ? 1 : 0);
        setLoader(true)
        SaveUploadFileDocDetails(multipartFormData, (callback) => {
            setLoader(false)
            console.log(callback)
            if (callback == "success") {
                setPopupData({ show: true, popupData: "Document Uploaded Successfully" })
            } else {
                setPopupData({ show: true, popupData: "Error Uploading Document" })
            }
            removePopup()

        })
    }

    const closePopup = () => {
        setPopupData({ show: false, popupData: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }


    const getFileExt = (fileName) => {
        const lastDotIndex = fileName.lastIndexOf(".");
        const extension = lastDotIndex !== -1 ? fileName.slice(lastDotIndex + 1).toLowerCase() : "";
        const fE = extension == "pdf" ? "pdf" : extension == "png" || extension == "jpg" || extension == "jpeg" ? "img" : ''
        return fE
    }

    const handleDownloadDoc = (data) => {
        const [before, after] = data?.documentUrl?.split("?downloadfile=");
        const [newbef, newaft] = after?.split("&type=")
        setLoader(true)
        DirectDownloadAnyFileByFileName(newbef,newaft, callback => {
            setLoader(false)
        })
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }

            {
                PopupData?.show ?
                    <Popup
                        closePopup={closePopup}
                        popupStatus={PopupData?.popupData}
                    />
                    : ''}
            <div className="container-fluid" style={{ marginTop: '50px' }}>
                <div className="row">
                    <div className="col-sm-2 col-xs-4" style={{ margin: '30px 0', float: 'right', textAlign: 'center' }}>
                        <button className='btn ' style={{ backgroundColor: '#064254', color: '#fff', padding: '13px 15px' }} onClick={e => actionHandler('add', '')}><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </div>
                    <div className="col-xs-12">
                        <div className='table-responsive '>
                            {tableData?.length > 0 ?
                                <>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className='table credhub-table'>
                                            <thead>
                                                <tr>
                                                    <th scope="col">Document Name</th>
                                                    <th scope='col'>Document Type</th>
                                                    <th scope='col'>Added On</th>

                                                    <th scope="col">Edit</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData?.map((row, i) => {
                                                    return (
                                                        <tr key={i}>


                                                            <td>{row?.documentName || "-"}</td>
                                                            <td>{row?.documentType || "-"}</td>
                                                            <td>{getDates(row?.addedOn) || "-"}</td>
                                                            <td>
                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <i className="fa fa-download" onClick={e => handleDownloadDoc(row)} style={{ marginRight: '15px' }} />
                                                                    <i className="fa fa-eye" onClick={e => actionHandler('view', row)} style={{ marginRight: '15px' }} />
                                                                    <i className='fa fa-edit' onClick={e => actionHandler('edit', row)} />
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        count={Math.ceil(tableData?.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        style={{ display: 'flex', justifyContent: 'end' }}
                                    />
                                </>
                                :
                                <p style={{ marginTop: '100px' }} className="text-center">
                                    <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                                </p>
                            }
                        </div>
                    </div>
                </div>

                {
                    AddDocumentPopup ?
                        <div className="popup-main small-popup container-fluid   " style={{ padding: '20px', borderRadius: '10px', width: '800px' }}>
                            <i onClick={() => actionHandler("closePopup", "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h5 className="" style={{ marginBottom: '5px', marginTop: '5px', fontWeight: '700' }}><i class="fa fa-file-text" aria-hidden="true" style={{ fontSize: '20px' }}></i>&nbsp;&nbsp; Upload Document</h5>
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '15px' }}>
                                <div className="col-sm-3 col-xs-4">
                                    <label htmlFor="">Document Type</label>
                                    <select className='form-control' value={uploadDocumentData?.documentNameSelected} onChange={(e) => handleUploadFile(e, "docName")} disabled={disableSelectBox}>
                                        <option value="">Select Option</option>
                                        {
                                            ListData && ListData?.length > 0 ? ListData?.map((value, index) => (
                                                <option value={value?.name}>{value?.name}</option>
                                            ))
                                                : ''}
                                    </select>
                                </div>

                                {
                                    popupListData && popupListData?.length > 0 ?
                                        <div className="col-xs-12" style={{ marginTop: '15px' }}>
                                            <table className='table credhub-table'>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Document Name</th>
                                                        <th scope='col'>Document Type</th>
                                                        <th scope='col'>Doc Types Allowed</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr >
                                                        <td>{popupListData[0]?.name || "-"}</td>
                                                        <td>{popupListData[0]?.type || "-"}</td>
                                                        <td>{popupListData[0]?.docTypesAllowed?.length > 0 ? concatenatedString(popupListData[0]?.docTypesAllowed) : "-"}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        : ''}
                                {
                                    uploadDocumentData?.documentNameSelected !== "" ?
                                        <div className="col-xs-12" style={{ marginTop: '15px' }}>
                                            <div className="customUploadInputNew" style={{ margin: '15px 0' }}>
                                                <input type="file" className='customUploadInputTag' onChange={e => handleUploadFile(e, "docupload")} />
                                                <div className="text">
                                                    <i class="fa fa-cloud-upload" aria-hidden="true" style={{ fontSize: '30px', color: '#1B6BFE' }}></i>
                                                    {
                                                        uploadDocumentData?.documentName !== "" && uploadDocumentData?.documentName !== null && uploadDocumentData?.documentName !== undefined ?
                                                            <h5>{uploadDocumentData?.documentName}</h5>
                                                            :
                                                            <>
                                                                <h5>Click to Upload <span>or drag and drop</span></h5>
                                                                {/* <h6> (Max. File size: 10 MB)</h6> */}
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        : ''}
                                {
                                    uploadDocumentData?.file != "" && uploadDocumentData?.file != null && uploadDocumentData?.file !== undefined ?
                                        <div className="col-xs-12 text-center">
                                            <button className='btn btn-primary' onClick={() => handleSave()}>Upload</button>
                                        </div>
                                        : ''}
                            </div>
                        </div>
                        : ''}

                {
                    viewDocumentPopup?.show ?
                        <div className="popup-main  container-fluid   " style={{ padding: '20px', borderRadius: '10px', width: '800px', height: '500px' }}>
                            <i onClick={() => actionHandler("closePopup", "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h5 className="" style={{ marginBottom: '5px', marginTop: '5px', fontWeight: '700' }}><i class="fa fa-file-text" aria-hidden="true" style={{ fontSize: '20px' }}></i>&nbsp;&nbsp; View {viewDocumentPopup?.data?.documentName || "Document"}</h5>
                                </div>

                                <div className="col-xs-12" style={{ marginTop: '25px' }}>
                                    <div style={{ width: '100%', height: '360px', marginTop: '15px' }}>
                                        <iframe src={viewDocumentPopup?.data?.documentUrl} width={"100%"} height={"100%"}></iframe>
                                    </div>
                                </div>
                            </div>

                        </div>
                        : ''}
            </div>
        </>
    )
}
